/**
 * Product analytics from inside the workbench package (IMPLEMENTATION.md R10 step 1,
 * docs/admin-analytics-brief.md, docs/runbooks/product-analytics.md). The package owns no event
 * stream: the app installs one through `setProductTracker` at start-up and Paige's flows in this
 * folder call `trackProduct` with a fixed name (`area.action`) and a short detail. With no tracker
 * installed (tests, the component catalogue) every call is a no-op. A detail is a count, a kind or
 * a flag; never a field value, a file name, a path, document content or an id.
 */
export type ProductDetail = Record<string, string | number | boolean>;

export type ProductTracker = (name: string, detail?: ProductDetail) => void;

let tracker: ProductTracker | null = null;

/** The app's event stream, or null to take it away (tests). */
export function setProductTracker(track: ProductTracker | null): void {
  tracker = track;
}

/** Records one product event; nothing happens when no tracker is installed or the tracker throws. */
export function trackProduct(name: string, detail?: ProductDetail): void {
  if (!tracker) return;
  try {
    tracker(name, detail);
  } catch {
    // Analytics never breaks the flow it observes.
  }
}
